import styled from "styled-components";

export const DashboardDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;
`;
